/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum permissionAction {
    ALLOW = 'allow',
    DENY = 'deny',
    NONE = 'none',
}